/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".customSortDownLabel[_ngcontent-%COMP%], .customSortUpLabel[_ngcontent-%COMP%] {\r\n    right: -3px;\r\n    position: relative;\r\n}\r\n\r\n.customHeaderMenuButton[_ngcontent-%COMP%] {\r\n    position: absolute;\r\n    right: 10px;\r\n}\r\n\r\n\r\n\r\n.custom-filter[_ngcontent-%COMP%] {\r\n    padding: 5px 0;\r\n}\r\n\r\n.custom-filter[_ngcontent-%COMP%]   .filter-title[_ngcontent-%COMP%] {\r\n    margin-bottom: 5px;\r\n}"];
export { styles as styles };
